<template>
  <div class="m-ribbon">
    <button
      v-for="(s, i) in stages"
      :key="s.key || i"
      type="button"
      class="m-ribbon__stage"
      :class="{ 'is-active': isActive(s) }"
      @click="select(s)"
    >
      <span class="m-ribbon__top">
        <CygnusIcon v-if="s.icon" :name="s.icon" />
        <span>{{ s.label }}</span>
      </span>
      <span class="m-ribbon__num">{{ s.count }}</span>
      <span v-if="s.meta" class="m-ribbon__meta">{{ s.meta }}</span>
      <span v-if="i < stages.length - 1" class="m-ribbon__chev">›</span>
    </button>
  </div>
</template>

<script>
/**
 * MusubiJourneyRibbon — a clickable lifecycle/pipeline ribbon (Discover →
 * Enrich → Qualify → …). `v-model` binds the active stage key; clicking a
 * stage also emits `select`.
 *
 *   <MusubiJourneyRibbon v-model="stage" :stages="stages" @select="onSelect" />
 *   stages: [{ key, label, count, meta?, icon? }]
 */
export default {
  name: 'MusubiJourneyRibbon',
  props: {
    stages:     { type: Array,  required: true },
    /** active stage key (v-model). */
    modelValue: { type: [String, Number], default: null },
  },
  emits: ['update:modelValue', 'select'],
  methods: {
    isActive(s) { return this.modelValue != null && (s.key ?? s.label) === this.modelValue; },
    select(s) {
      const key = s.key ?? s.label;
      this.$emit('update:modelValue', key);
      this.$emit('select', s);
    },
  },
};
</script>

<style scoped>
.m-ribbon {
  display: flex; background: var(--m-bg-card); border: 1px solid var(--m-border);
  border-radius: var(--m-radius-lg); padding: 7px; box-shadow: var(--m-shadow-card);
}
.m-ribbon__stage {
  flex: 1; position: relative; text-align: left; cursor: pointer;
  background: none; border: none; border-radius: var(--m-radius); padding: 12px 14px;
  font: inherit; color: inherit;
}
.m-ribbon__stage:hover { background: var(--m-bg-content); }
.m-ribbon__stage.is-active { background: var(--m-accent-soft); box-shadow: inset 0 0 0 1.5px var(--m-accent); }
.m-ribbon__top { display: flex; align-items: center; gap: 7px; color: var(--m-text-secondary); font-size: 0.78rem; font-weight: 600; }
.m-ribbon__top i { color: var(--m-accent); }
.m-ribbon__num { display: block; font-size: var(--m-text-xl); font-weight: 750; margin-top: 4px; color: var(--m-text-primary); }
.m-ribbon__meta { display: block; font-size: 0.7rem; color: var(--m-text-tertiary); }
.m-ribbon__chev { position: absolute; right: -6px; top: 50%; transform: translateY(-50%); color: var(--m-border-strong); font-size: 1.1rem; }
</style>
